import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter } from 'react-router-dom'
import { initKeyboardAwareInputs } from './utils/keyboardAwareInputs'

initKeyboardAwareInputs()

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode >

        <HelmetProvider context={{}}>
            <App />
        </HelmetProvider>

    </React.StrictMode>,
)
